"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var Container_1 = __importDefault(require("./Container"));
var LogoAndName = function (_a) {
    var _b, _c;
    var url = _a.url, _d = _a.targetUrl, targetUrl = _d === void 0 ? '_self' : _d, _e = _a.fontWeight, fontWeight = _e === void 0 ? 'regular' : _e, _f = _a.noWrap, noWrap = _f === void 0 ? true : _f, props = __rest(_a, ["url", "targetUrl", "fontWeight", "noWrap"]);
    return ((0, jsx_runtime_1.jsxs)(Container_1.default, __assign({ component: url ? react_router_dom_1.Link : 'div', fontWeight: fontWeight, isLink: !!url, size: (props === null || props === void 0 ? void 0 : props.size) || 'md', noWrap: noWrap, 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        target: targetUrl, to: url && { pathname: url } }, { children: [(0, jsx_runtime_1.jsx)(Logo_1.default, __assign({}, props)), (0, jsx_runtime_1.jsx)("span", __assign({ className: "LogoAndName_label" }, { children: ((_b = props.brand) === null || _b === void 0 ? void 0 : _b.niceName) || ((_c = props.brand) === null || _c === void 0 ? void 0 : _c.name) || 'Service' }))] })));
};
exports.default = react_1.default.memo(LogoAndName);
